
import React, { useState , useEffect } from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import ReviewDetailData from "./ReviewDetailData";

export default function ReviewDetail( { record }) {
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState('center');
    // const footerContent = (
    //     <div>
    //         <Button label="No" icon="pi pi-times" onClick={() => setVisible(false)} className="p-button-text" />
    //         <Button label="Yes" icon="pi pi-check" onClick={() => setVisible(false)} autoFocus />
    //     </div>
    // );

    useEffect(() => {

        console.log( "record = " , record )

        if ( record !== null )
        {
            show()
        }

    } , [record])



    const show = (position) => {
        //setPosition(position);
        setVisible(true);
    };

    return (
        <div className="card">

            <Dialog header="Detalle" visible={visible} position={position} style={{ width: '80vw' }} onHide={() => {if (!visible) return; setVisible(false); }}  draggable={false} resizable={false}>
                <ReviewDetailData record={record}></ReviewDetailData>
            </Dialog>
        </div>
    )
}
        